import StockSettingsApi, {IWarehouse} from "../../api/StockSettingsApi"
import {makeAutoObservable} from "mobx";
import stockSettingsController from "../pageControllers/StockSettingsController";
import WarehouseCondition from "./WarehouseConditions"
import {SelectProductsState} from "../../components/SelectProductsCategoriesOrSets";


export default class Warehouse implements IWarehouse {
    constructor(warehouse: IWarehouse) {
        this._infinity_count = warehouse.infinity_count
        this._stock_mode = warehouse.stock_mode
        this._stocks = warehouse.stocks
        this._update_stocks = warehouse.update_stocks
        this._id = warehouse.id
        this._is_rfbs = warehouse.is_rfbs
        this._name = warehouse.name
        this._write_off_goods = warehouse.write_off_goods
        this._not_found_zero = warehouse.not_found_zero
        this._productCollectionSettings = warehouse.productCollectionSettings
        console.log(warehouse)
        if (warehouse.conditions) {
            warehouse.conditions.map((condition) => this._conditions.push(new WarehouseCondition(() => this.saveWarehouseSettings(), condition)))
        }
        makeAutoObservable(this)

        if (this._stock_mode === 'selected') {
            if (stockSettingsController.shop_warehouses.length === 0) {
                this.stock_mode = "all"
            }
        }
    }

    private _conditions: WarehouseCondition[] = []

    get conditions(): WarehouseCondition[] {
        return this._conditions
    }

    private _productCollectionSettings: SelectProductsState = {
        selectType: 'fromExport',
        productCollectionType: 'categories',
        selectedCategories: [],
        selectedSets: [],
    }

    get productCollectionSettings(): SelectProductsState {
        return this._productCollectionSettings;
    }

    set productCollectionSettings(value: SelectProductsState) {
        this._productCollectionSettings = value;
        this.saveWarehouseSettings()
    }

    private _write_off_goods: boolean;

    get write_off_goods(): boolean {
        return this._write_off_goods;
    }

    set write_off_goods(value: boolean) {
        this._write_off_goods = value;
        this.saveWarehouseSettings()
    }

    private _not_found_zero: boolean;

    get not_found_zero(): boolean {
        return this._not_found_zero;
    }

    set not_found_zero(value: boolean) {
        this._not_found_zero = value;
        this.saveWarehouseSettings()
    }

    private _infinity_count: string

    get infinity_count(): string {
        return this._infinity_count
    }

    set infinity_count(value: string) {
        this._infinity_count = value
        this.saveWarehouseSettings()
    }

    private _stock_mode: "all" | "selected"

    get stock_mode(): "all" | "selected" {
        return this._stock_mode
    }

    set stock_mode(value: "all" | "selected") {
        this._stock_mode = value
        if (value === "all") {
            this._stocks = []
        }
        this.saveWarehouseSettings()
    }

    private _stocks: string[]

    get stocks(): string[] {
        return this._stocks
    }

    set stocks(value: string[]) {
        this._stocks = value
        this.saveWarehouseSettings()
    }

    private _update_stocks: boolean

    get update_stocks(): boolean {
        return this._update_stocks
    }

    set update_stocks(value: boolean) {
        this._update_stocks = value
        this.saveWarehouseSettings()
    }

    private _id: string

    get id(): string {
        return this._id
    }

    private _is_rfbs: boolean

    get is_rfbs(): boolean {
        return this._is_rfbs
    }

    private _name: string

    get name(): string {
        return this._name
    }

    changeWarehouse(id: string, checked: boolean) {
        if (checked) {
            if (!this.stocks.includes(id)) {
                this._stocks.push(id)
            }
        } else {
            if (this.stocks.includes(id)) {
                const index = this.stocks.indexOf(id)
                if (index !== -1) {
                    this._stocks.splice(index, 1);
                }
            }
        }
        this.saveWarehouseSettings()
    }

    addCondition() {
        this._conditions.push(new WarehouseCondition(() => this.saveWarehouseSettings()))
        this.saveWarehouseSettings()
    }

    deleteCondition(id: number) {
        this._conditions.splice(id, 1)
        this.saveWarehouseSettings()
    }

    private saveWarehouseSettings() {
        StockSettingsApi.saveWarehouse(
            {
                id: this.id,
                is_rfbs: this.is_rfbs,
                name: this.name,
                infinity_count: this.infinity_count,
                stock_mode: this.stock_mode,
                update_stocks: this.update_stocks,
                stocks: this.stocks,
                write_off_goods: this.write_off_goods,
                not_found_zero: this.not_found_zero,
                conditions: this.conditions.map((condition) => ({
                    type: condition.type,
                    if_value: condition.if_value,
                    then_value: condition.then_value
                })),
                productCollectionSettings: this.productCollectionSettings
            })
    }
}